type TFunc = (key: string) => string

export function getOfficialExampleLayoutHtml(t: TFunc): string {
  return `<style>
/* Global Base Styles - Scoped to Tipsy elements only */
[id^="tipsy-"],
[id^="tipsy-"] * {
    font-family: "Garamond", "Times New Roman", serif !important;
    box-sizing: border-box !important;
}

/* Tagline text area width - Reset max-width first then set width */
#tipsy-tagline-content {
    max-width: 100% !important;
    width: 95% !important;
    margin: 0 auto !important;
    color: #5a3e2b !important;
    font-size: 16px !important;
    line-height: 1.6 !important;
}

/* Overall spacing between messages */
#tipsy-message-gap {
    height: 12px !important; /* Moderate retro spacing */
}

/* Spacing between sub-messages in character message container */
#tipsy-char-msg-content {
    gap: 8px !important;
    padding: 0 8px !important;
}

/* === ${t('layout_example_char_bubble_replace_start')} === */
/* Character message bubble - Retro brown main style */
#tipsy-char-message-bubble {
    background: #f8f0e0 !important; /* Light brown background */
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAUVBMVEWFhYWDg4N3d3dtbW17e3t1dXWBgYGHh4d5eXlzc3OLi4ubm5uVlZWPj4+NjY19fX2JiYl/f39ra2uRkZGZmZlpaWmXl5dvb29xcXGTk5NnZ2c8AAAAG3RSTlNAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAvEOwtAAAFVklEQVR4XpWWB67c2BUFb3g557T/hRo9/WUMZHlgr4Bg8Z4qQgQJlHI4A8SzFVrapvmTF9O7dmYRFZ60YiBhJRCgh1FYhiLAmdvX0CzTOpNE77ME0Zty/nWWzchDtiqrmQDeuv3powQ5ta2eN0FY0InkqDD73lT9c9lEzwUNqgFHs9VQce3TVClFCQrSTfOiYkVJQBmpbq2L6iZavPnAPcoU0dSw0SUTqz/GtrGuXfbyyBniKykOWQWGqwwMA7QiYAxi+IlPdqo+hYHnUt5ZPfnsHJyNiDtnpJyayNBkF6cWoYGAMY92U2hXHF/C1M8uP/ZtYdiuj26UdAdQQSXQErwSOMzt/XWRWAz5GuSBIkwG1H3FabJ2OsUOUhGC6tK4EMtJO0ttC6IBD3kM0ve0tJwMdSfjZo+EEISaeTr9P3wYrGjXqyC1krcKdhMpxEnt5JetoulscpyzhXN5FRpuPHvbeQaKxFAEB6EN+cYN6xD7RYGpXpNndMmZgM5Dcs3YSNFDHUo2LGfZuukSWyUYirJAdYbF3MfqEKmjM+I2EfhA94iG3L7uKrR+GdWD73ydlIB+6hgref1QTlmgmbM3/LeX5GI1Ux1RWpgxpLuZ2+I+IjzZ8wqE4nilvQdkUdfhzI5QDWy+kw5Wgg2pGpeEVeCCA7b85BO3F9DzxB3cdqvBzWcmzbyMiqhzuYqtHRVG2y4x+KOlnyqla8AoWWpuBoYRxzXrfKuILl6SfiWCbjxoZJUaCBj1CjH7GIaDbc9kqBY3W/Rgjda1iqQcOJu2WW+76pZC9QG7M00dffe9hNnseupFL53r8F7YHSwJWUKP2q+k7RdsxyOB11n0xtOvnW4irMMFNV4H0uqwS5ExsmP9AxbDTc9JwgneAT5vTiUSm1E7BSflSt3bfa1tv8Di3R8n3Af7MNWzs49hmauE2wP+ttrq+AsWpFG2awvsuOqbipWHgtuvuaAE+A1Z/7gC9hesnr+7wqCwG8c5yAg3AL1fm8T9AZtp/bbJGwl1pNrE7RuOX7PeMRUERVaPpEs+yqeoSmuOlokqw49pgomjLeh7icHNlG19yjs6XXOMedYm5xH2YxpV2tc0Ro2jJfxC50ApuxGob7lMsxfTbeUv07TyYxpeLucEH1gNd4IKH2LAg5TdVhlCafZvpskfncCfx8pOhJzd76bJWeYFnFciwcYfubRc12Ip/ppIhA1/mSZ/RxjFDrJC5xifFjJpY2Xl5zXdguFqYyTR1zSp1Y9p+tktDYYSNflcxI0iyO4TPBdlRcpeqjK/piF5bklq77VSEaA+z8qmJTFzIWiitbnzR794USKBUaT0NTEsVjZqLaFVqJoPN9ODG70IPbfBHKK+/q/AWR0tJzYHRULOa4MP+W/HfGadZUbfw177G2j8R8+lIlydZX9g5ejfE6Zh9qAKed4RwiVgaJQFIOE3NBJqFeoG8qCDGwwIBK95q7NQDwuNu5y99v7DrYfZP7Rh7EgF4zvM3VQ+uUyrNAtuZHVGkF5S5f+c5F3yQx98Nz8kML0CkYV24ATQvVkf8f8AAAAASUVORK5CYII=") !important;
    border: 2px solid #946b44 !important; /* Dark brown border */
    border-radius: 18px 18px 4px 18px !important; /* Retro rounded corners */
    padding: 12px 15px !important;
    margin: 4px 0 !important;
    color: #2d2418 !important;
    font-size: 14px !important;
    line-height: 1.7 !important;
    box-shadow: 0 3px 6px rgba(0,0,0,0.1) !important;
}
/* === ${t('layout_example_char_bubble_replace_end')} === */

/* Narration box style */
#tipsy-narration-box {
    background: linear-gradient(145deg, #3d2e1e 0%, #2a1f14 100%) !important;
    border: 2px dashed #946b44 !important;
    border-radius: 12px !important;
    padding: 10px 14px !important;
    margin: 10px auto !important;
    width: 90% !important;
    color: #d4b892 !important;
    font-style: italic !important;
    font-size: 13px !important;
    text-align: center !important;
}

/* User message bubble outer container width */
#tipsy-user-msg-content {
    width: 90% !important;
    margin-left: auto !important;
    padding-right: 8px !important;
}

/* User message bubble */
#tipsy-user-message-bubble {
    background: #946b44 !important; /* Dark brown background */
    color: #f8f0e0 !important; /* Light brown text */
    border-radius: 18px 18px 18px 4px !important;
    border: 2px solid #5a3e2b !important;
    padding: 12px 15px !important;
    margin: 4px 0 !important;
    font-size: 14px !important;
    line-height: 1.7 !important;
    box-shadow: 0 3px 6px rgba(0,0,0,0.1) !important;
}

/* Chat page header */
#tipsy-chat-header {
    background: #5a3e2b !important; /* Retro dark brown */
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E") !important;
    padding: 15px 10px !important;
    border-bottom: 4px solid #946b44 !important;
}

#tipsy-chat-header h1, #tipsy-chat-header h2, #tipsy-chat-header h3 {
    color: #f8f0e0 !important;
    text-align: center !important;
    text-transform: uppercase !important;
    letter-spacing: 2px !important;
    font-weight: 700 !important;
}

/* Chat message list overall container */
/* === ${t('layout_example_chat_bg_replace_start')} === */
#tipsy-chat-container {
    background: #2a1f14 !important;
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23946b44' fill-opacity='0.15' fill-rule='evenodd'/%3E%3C/svg%3E") !important;
    padding: 10px !important;
    height: calc(100vh - 200px) !important;
    overflow-y: auto !important;
}
/* === ${t('layout_example_chat_bg_replace_end')} === */

/* Chat page bottom area (below input box) */
#tipsy-chat-bottom {
    background: #5a3e2b !important;
    padding: 10px !important;
    border-top: 3px solid #946b44 !important;
}

/* Character card button style */
#tipsy-role-card-button {
    background: linear-gradient(145deg, #946b44 0%, #7a5438 100%) !important;
    color: #f8f0e0 !important;
    border: 2px solid #5a3e2b !important;
    border-radius: 12px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
}

#tipsy-role-card-button:hover {
    background: linear-gradient(145deg, #7a5438 0%, #946b44 100%) !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.2) !important;
}

/* Input box style */
#tipsy-chat-input-area {
    width: 90% !important;
    margin: 0 auto !important;
    background: #2a1f14 !important;
    border: 3px solid #946b44 !important;
    border-radius: 20px !important;
    padding: 12px 18px !important;
    font-size: 14px !important;
    color: #d4b892 !important;
    resize: none !important;
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.2) !important;
}

#tipsy-chat-input-area:focus {
    outline: none !important;
    border-color: #8b0000 !important;
    box-shadow: 0 0 8px rgba(139, 0, 0, 0.2) !important;
}

/* Scrollbar beautification - Match retro style */
#tipsy-chat-container::-webkit-scrollbar {
    width: 8px !important;
}

#tipsy-chat-container::-webkit-scrollbar-track {
    background: #f2e9d8 !important;
    border-radius: 4px !important;
}

#tipsy-chat-container::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #946b44 0%, #5a3e2b 100%) !important;
    border-radius: 4px !important;
}

#tipsy-chat-container::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #5a3e2b 0%, #946b44 100%) !important;
}
</style>`
}
